import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const LanguageSelector = ({ isMy = false }) => {
  const { i18n } = useTranslation('general')

  function handleChangeLanguage(lang) {
    return () => {
      i18n.changeLanguage(lang)
    }
  }

  const languages = {
    en: 'English',
    ...(isMy ? {} : { 'zh-TW': '繁體中文' }),
    'zh-CN': '简体中文',
  }

  return (
    <ul>
      {Object.entries(languages).map(([key, name]) => (
        <li key={key}>
          <a onClick={handleChangeLanguage(key)}>{name}</a>
        </li>
      ))}
    </ul>
  )
}

LanguageSelector.propTypes = {
  isMy: PropTypes.bool,
}

export default LanguageSelector
